import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

// This is required because NextJS doesn't load scripts on page navigation
// It only executes script tags on initial page load to refresh
// This checks for a rich text element and loops over any scripts
// that are found to readd them to the dom for execution upon route change

export const useUrlChangeListener = (analyticsScriptSource: string) => {
  const router = useRouter();
  const [analyticsloaded, setAnalyticsLoaded] = useState(false);

  useEffect(() => {
    const completeHandler = () => {
      const containers = document?.querySelectorAll('[data-testid="rich-text-rendering"]');

      if (document && containers) {
        containers.forEach((container) => {
          const hasChildScriptElement = container?.contains(container?.querySelector('script'));

          if (hasChildScriptElement) {
            const scripts = container?.querySelectorAll('script');
            scripts?.forEach((script) => {
              const generateScriptTag = document.createElement('script');
              generateScriptTag.textContent = script.textContent;
              Array.from(script.attributes).forEach((attr) =>
                generateScriptTag.setAttribute(attr.name, attr.value)
              );
              script?.parentElement?.replaceChild(generateScriptTag, script);
            });
          }
        });
      }

      if (analyticsScriptSource) {
        const analyticsScript = document.createElement('script');
        analyticsScript.src = analyticsScriptSource;
        analyticsScript.addEventListener('load', () => setAnalyticsLoaded(true));
        document.body.appendChild(analyticsScript);
      }
    };

    router.events.on('routeChangeComplete', completeHandler);

    return () => {
      router.events.off('routeChangeComplete', completeHandler);
    };
  }, [router.events, analyticsloaded, analyticsScriptSource]);
};
